import React from 'react';
import { TextField, useRecordContext } from 'react-admin';
import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { TextQuestionParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Företagsnamn',
  [languages.EN]: 'Company name',
  [languages.DE]: 'Firmenname',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const CompanyName = ({ extraParameters }: { extraParameters?: TextQuestionParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      datapoint={conflictFields.COMPANY_NAME}
      identificationInfo={undefined}
      source="companyName"
    >
      <ValueField />
    </Answer>
  );
};

CompanyName.ValueField = ValueField;

export default CompanyName;
